import React, { Component } from 'react'
import ToastMsg from '../../../../Components/ToastMsg/ToastMsg'
import { Autocomplete, Box, Button, IconButton, Menu, MenuItem, Modal, Table, TableBody, TableCell, TableHead, TableRow, TextField, Tooltip, Typography, CircularProgress } from '@mui/material'
import CommonGridHeader, { CommonPatientCard, CommonPatientDetails, OpenWebCamPopUP, DeletePopup, CommonDeleteButton } from '../../../../Components/Common Components/CommonComponents'
import { getCachevalue, localGetItem } from '../../../../Utility/Services/CacheProviderService'
import { Colors } from '../../../../Styles/Colors'
import Loader from '../../../../Components/Loader';
import RestAPIService from '../../../../Utility/Services/RestAPIService'
import { Serviceurls } from '../../../../Utility/API/Serviceurls'
import { DataGrid } from '@mui/x-data-grid'
import { DateTime } from 'luxon'
import { DatePicker, LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns'
import { ImagePaths } from '../../../../Utility/ImagePaths'
import CancelTwoToneIcon from '@mui/icons-material/CancelTwoTone';
import './Reports.css';
import KeyboardDoubleArrowLeftIcon from '@mui/icons-material/KeyboardDoubleArrowLeft';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import { formatDate, dataURItoFile, fetchAndConvertToBase64 } from '../../../../Components/CommonFunctions/CommonFunctions'
import { Bucket_Name } from '../../../../Utility/Constants'
import FileUploadIcon from '@mui/icons-material/FileUpload';
import PrintPreviewPop from '../../../../Components/Common Components/PrintPreviewPop'
import MoreVertIcon from '@mui/icons-material/MoreVert';
import DocumentPreviewPop from '../../../../Components/Common Components/DocumentPreviewPop'


let AWS = require('aws-sdk');
let s3 = new AWS.S3({
  region: "ap-south-1"
});

const reportType = [
  { label: "Laboratory", value: "Laboratory" },
  { label: "Radiology", value: "Radiology" },
  { label: "Special", value: "Special" },
  { label: "Eye Test", value: "Eye Test" },
  { label: "Investigation", value: "Investigation" }
];

export default class DocTestReport extends Component {
  constructor(props) {
    super(props)
    this.state = {
      patientDetails: {},
      clinicId: '',
      appointmentId: '',
      patientId: '',
      page: 0,
      pageSize: 10,
      testReportData: [],
      startDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      endDate: DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'),
      dateIndex: 0,
      reportTypes: reportType,
      selectedReportType: '',
      selectedDate: new Date(),
      open: false,
      imageuploadList: [],
      imageViewerPopup: false,
      viewData: [],
      viewImage: null,
      loading: false,
      selectedImage: null,
      addTestData: false,
      historyPopup: false,
      labhistory: [],
      test_date: [],
      imgCapClked: false,
      CapturedImg: null,
      deletedPopup: false,
      deleteId: null,
      printPreviewPop: false,
      printPreviewData: [],
      pdfName: '',
      selectedRow: null,
      s3Loading: false,
    }
    this.uploadImage = React.createRef();
  }

  componentDidMount() {
    let clinicId = getCachevalue('SelectedDoctorClinic')
    let appointmentId = this.props.fromOT ? JSON.parse(getCachevalue("OTpatientData")) : JSON.parse(getCachevalue('DoctorPatientData'))
    this.setState({
      clinicId: clinicId,
      appointmentId: appointmentId?.appointment_id,
      patientId: appointmentId?.patient_id,
      patientDetails: appointmentId,
    }, () => {
      this.getPatientDetailData()
      this.getTestReportData()
      this.getlabhistorytestreport()
    })
  }

  getPatientDetailData = () => {
    try {
      RestAPIService.getAll(Serviceurls.DOC_PATIENT_DETAIL_GET + '?patient_id=' + this.state.patientId)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              patientDetails: {...this.state.patientDetails, ...response?.data?.data}
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  getTestReportData = () => {
    try {
      this.setState({ loading: true })
      RestAPIService.getAll(Serviceurls.DOC_DOCTOR_TEST_REPORT + `?patient_id=${this.state.patientId}&clinic_id=${this.state.clinicId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              testReportData: response?.data?.data,
              loading: false
            })
          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ loading: false })
      this.errorMessage(error.message)
    }
  }

  getTestReportPrint = (resultSummaryId, labId) => {
    try {
      RestAPIService.getAll(Serviceurls.LAB_PATIENT_RESULT_PRINT + `?result_summary_id=${resultSummaryId}&laboratory_id=${labId}`)
        .then((response) => {
          const file = new Blob(
            [response.data],
            { type: 'application/pdf' });
          const fileURL = URL.createObjectURL(file);
          window.open(fileURL);
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.errorMessage(error.response.data.message)
          } else {
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  postTestReportData = () => {
    try {
      let { imageuploadList } = this.state
      this.setState({ addTestData: true })
      const dataForm = new FormData();
      dataForm.append('patient_id', this.state.patientId)
      dataForm.append('report_date', this.state.selectedDate ? DateTime.fromJSDate(this.state.selectedDate).toFormat('yyyy-MM-dd') : DateTime.fromJSDate(new Date()).toFormat('yyyy-MM-dd'))
      dataForm.append('report_type', this.state.selectedReportType)
      dataForm.append('comment', this.state.testReportComments ? this.state.testReportComments : '')
      dataForm.append('appointment_id', this.state.appointmentId)
      dataForm.append('clinic_id', this.state.clinicId)

      for (let i = 0; i < imageuploadList.length; i++) {
        // if (imageuploadList[i]["type"] === "application/pdf") {
        //   dataForm.append("report_file_pdf", imageuploadList[i])
        // }
        // if (imageuploadList[i]["type"] !== "application/pdf") {
        // dataForm.append("report_file", imageuploadList[i])
        dataForm.append('report_photo', imageuploadList[i])
        // }
      }
      let validate = this.checkValidation()
      if (validate === null) {
        RestAPIService.create(dataForm, Serviceurls.DOC_DOCTOR_TEST_REPORT_POST)
          .then((response) => {
            if (response?.data?.status === 'success') {
              this.setState({ addTestData: false })
              this.successMessage(response?.data?.message)
              this.onClearTestReportData()
              this.getTestReportData()
            }
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.setState({ addTestData: false })
              this.errorMessage(error.response.data.message)
            } else {
              this.setState({ addTestData: false })
              this.errorMessage(error.message)
            }
          })
      } else {
        this.setState({ addTestData: false })
        this.errorMessage(validate)
      }
    } catch (error) {
      this.setState({ addTestData: false })
      this.errorMessage(error.message)
    }
  }

  errorMessage = (message) => {
    this.setState({
      isErrorMsg: true,
      isErrorMsgText: message
    })
  }

  successMessage = (message) => {
    this.setState({
      successMsg: true,
      successMsgText: message
    })
  }

  LoaderFunction = (key) => {
    this.setState({
      isLoader: key
    })
  }

  msgClose() {
    this.setState({
      isErrorMsg: false,
      isErrorMsgText: '',
      successMsg: false,
      successMsgText: ''
    })
  }

  async getS3Key(doc_key, id) {
    try {
        const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(doc_key));

        if (response.data.status === "success") {
            const Data = response.data;
            return {
                data_url: Data.data
            };
        }
    } catch (e) {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: "Error fetching S3 URL"
        });
    }
}

  getlabhistorytestreport = () => {
    try {
      this.setState({ loading: true })
      RestAPIService.getAll(Serviceurls.DOC_LAB_HISTORY_TEST_REPORT_DB + `?patient_id=${this.state.patientId}&clinic_id=${this.state.clinicId}`)
        .then((response) => {
          if (response?.data?.status === 'success') {
            this.setState({
              labhistory: response?.data.data ? response?.data.data : [],
              loading: false
            }, () => {
              let Date = []
              if (this.state.labhistory?.length > 0) {
                Date = Object.keys(this.state.labhistory[0])
                if (Date?.indexOf("test_name") > -1) { Date?.splice(Date?.indexOf("test_name"), 1) }
              }
              this.setState({ test_date: Date })
            })

          }
        }).catch((error) => {
          if (error?.response?.data?.message) {
            this.setState({ loading: false })
            this.errorMessage(error.response.data.message)
          } else {
            this.setState({ loading: false })
            this.errorMessage(error.message)
          }
        })
    } catch (error) {
      this.setState({ loading: false })
      this.errorMessage(error.message)
    }
  }

  async renderImage(imageData, pdfData) {
    let tempArr = [];
    if (imageData.length > 0) {
      for (let i = 0; i < imageData.length; i++) {
        let image = imageData[i].result_img_url
        if (image !== null) {
          let doc_key = image;
          let getData = await this.getS3Key(doc_key)
          getData["type"] = image.split('.').pop() === "pdf" ? "pdf" : "image"
          tempArr.push(getData)
        }
      }
    }
    // if (pdfData.length > 0) {
    //   for (let i = 0; i < pdfData.length; i++) {
    //     let pdf = pdfData[i].result_img_url
    //     if (pdf !== null) {
    //       let pdf_key = pdf;
    //       let getPdf = await this.getS3Key(pdf_key)
    //       getPdf["type"] = "pdf"
    //       tempArr.push(getPdf)
    //     }
    //   }
    // }
    this.setState({
      viewData: tempArr,
      viewImage: tempArr[0]
    }, () => {
      if (pdfData) {
        window.open(this.state.viewImage.data_url)        
      }
    })
  }

  onImageHandler = async (e) => {
    const imageList = [];
    let imageFiles = [...e.target.files];
    let clearedArr = imageFiles?.filter((image, i) => {
      let file = image?.name;
      return String(file).toLowerCase() !== String(imageFiles[i + 1]?.name).toLowerCase()
    });
    // convert images to base64;
    for (let i = 0; i < clearedArr.length; i++) {
      imageList.push(clearedArr[i])
    }
    const newList = await Promise.all(imageList)
    this.setState((prevState) => ({
      imageuploadList: [...prevState.imageuploadList, ...newList]
    }))
    e.target.value = ''
  }

  onImageRemove = (index) => {
    let { imageuploadList } = this.state;
    // let deletedArr = [...imgUpload]
    // let index = deletedArr.findIndex(image => String(image["name"]).toLowerCase() === String(imgName).toLowerCase())
    imageuploadList.splice(index, 1)
    this.setState({
      imageuploadList: this.state.imageuploadList,
    })
  }

  onClearTestReportData = () => {
    try {
      this.setState({
        imageuploadList: [],
        selectedImage: null,
        viewData: [],
        viewImage: null,
        date: new Date(),
        selectedReportType: '',
        testReportComments: ''
      })
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  prevImage = (index) => {

    let { viewData } = this.state;

    let currentIndex = parseInt(index) || 0;

    if (currentIndex >= 1) {
      this.setState({
        currentIndex: currentIndex - 1,
        viewImage: viewData[currentIndex - 1]
      })
    }
  }

  nextImage = (index) => {

    let { viewData } = this.state;

    let currentIndex = parseInt(index) || 0;

    if ((currentIndex + 1) < viewData.length) {
      this.setState({
        currentIndex: currentIndex + 1,
        viewImage: viewData[currentIndex + 1]
      })
    }
  }

  checkValidation = () => {
    try {
      let validate = null;
      if ((this.state.selectedReportType === '') && (this.state.imageuploadList?.length === 0)) {
        validate = 'Enter all mandatory fields'
      } else if (this.state.selectedReportType === '') {
        validate = 'Select or Enter Report Type'
      } else if (this.state.imageuploadList?.length === 0) {
        validate = 'Upload atleast one Image'
      }
      return validate;
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  renderImageViewerPopup = () => {
    try {
      return (
        <Box component={'div'}>
          {
            this.state.viewData?.length > 0 ?

              < Modal
                open={this.state.imageViewerPopup}
              >
                <Box className='eMed_Doc_Img_Pop_Up'>
                  <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'1vw'} alignItems={'center'} justifyContent={'space-between'}>
                    <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Doctor Visit Report</Typography>
                    <Button
                      onClick={() => this.setState({
                        imageViewerPopup: false
                      })}
                    >
                      <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} mr={'1vw'} />
                    </Button>
                  </Box>
                  <Box height={'30vw'} display={'flex'} justifyContent={'center'}>
                    {this.state.viewData?.length > 1 ?
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Button size="small" className='Common_Btn_Min_Width' sx={{ height: '3vw' }} onClick={() => { this.prevImage(this.state.currentIndex) }}><KeyboardDoubleArrowLeftIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" /></Button>
                      </Box> : null
                    }

                    {this.state.viewImage.type === "pdf" ?
                      <Box>
                        <img style={{ width: '12vw', height: '12vw' }} src={ImagePaths.DocumentPreview.default} alt="slide" />
                        <Button variant="contained" onClick={() => { window.open(this.state.viewImage.data_url) }} emed_tid="doc_test_report_download_btn">Download Document</Button>
                      </Box>
                      :
                      <Box component={'div'} height={'30vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                        <img src={this.state.viewImage.data_url ? this.state.viewImage.data_url : ""} alt="slide" style={{ objectFit: 'contain', height: '15vw', width: '30vw' }} />
                      </Box>}

                    {this.state.viewData?.length > 1 ?
                      <Box component={'div'} display={'flex'} alignItems={'center'}>
                        <Button size="small" className='Common_Btn_Min_Width' sx={{ height: '3vw' }} onClick={() => { this.nextImage(this.state.currentIndex) }} emed_tid="doc_test_report_next_image_btn"><KeyboardDoubleArrowRightIcon className="eMed_testrp_arrowSize" fontSize="large" color="primary" /></Button>
                      </Box> : null
                    }
                  </Box>
                </Box>
              </Modal> : null
          }
        </Box >
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  handleDelete = (data) => {
    this.setState({
      deletedPopup: true,
      deleteId: data?.id,
    })
  }

  PopupClose = () => {
    this.setState({
      deletedPopup: false,
      deleteId: null,
    })
  }

  removeDataList = () => {
    try {
      RestAPIService.delete(`${Serviceurls.FO_TEST_REPORT_DELETE}?id=${this.state.deleteId}`)
        .then(response => {
          if (response.data.status === "success") {
            this.PopupClose();
            this.successMessage(response.data.message);
            this.getTestReportData();
          }
        })
        .catch(e => {
          this.errorMessage((e?.response?.data?.message || e?.message))
        });
    } catch (e) {
      this.errorMessage(e.message);
    }
  }

  moreActionOption = (data) => {
        const multi_option = [
          { label: "View Document", value: "viewDocument" },
        ];
        return (
          <div>
            <Tooltip title={"More"} placement='top' arrow>
              <IconButton
                onClick={(e) => {
                  this.setState({
                    anchorEl: e.currentTarget,
                    selectedRow: data.id,
                    isSelected: true
                  })
                }}
              >
                <MoreVertIcon />
              </IconButton>
            </Tooltip>
            {(this.state.isSelected && this.state.selectedRow == data.id) ?
              <Menu
                anchorEl={this.state.anchorEl}
                open={Boolean(this.state.anchorEl)}
                onClose={() => {
                  this.setState({ anchorEl: null })
                }}
              >
                {multi_option.map((option) => (
                  <MenuItem key={option}
                    disabled={option.value === "viewDocument" ? !(data?.result_document?.length > 0) : false}
                    onClick={() => {
                      if (option.value === "viewDocument") {
                        this.setState({ s3Loading: true });
                        this.getS3Keys(data?.result_document)
                      }
                    }}>
                    {option.label}
                    {option.value === "viewDocument" && this.state.s3Loading && (
                      <CircularProgress size={16} sx={{ ml: 1, color: '#04B7B1' }} />
                    )}
                  </MenuItem>
                ))}
              </Menu> : null}
          </div>
        )
      }
  
    async getS3Keys(documents) {
        try {
          if (!documents || documents.length === 0) return;
    
          let previewItems = [];
    
          for (const doc of documents) {
            const docName = doc.document_name;
            const docKey = doc.document_file;
    
            const response = await RestAPIService.getAllTwo(Serviceurls.AWS_URL_GET + "?doc_key=" + encodeURIComponent(docKey));
    
            if (response.data.status === "success") {
              const fileUrl = response?.data?.data;
              if (docName.toLowerCase().includes("jpg")) {
                // Fetch image and convert to blob object URL
                // const fileResponse = await fetch(fileUrl);
                // const blob = await fileResponse.blob();
                // const imageUrl = URL.createObjectURL(blob);
                previewItems.push({ type: "image", url: fileUrl, name: docName });
              } else {
                // PDF or other formats
                // const base64 = await fetchAndConvertToBase64(fileUrl);
    
                // const pdfBase64 = base64.replace(
                //   "data:binary/octet-stream;",
                //   "data:application/pdf;"
                // );
    
                previewItems.push({ type: "pdf", url: fileUrl, name: docName });
              }
            }
          }
    
          this.setState({
            printPreviewPop: true,
            printPreviewData: previewItems,
            pdfName: "Result Preview",
            s3Loading: false
          });
    
        } catch (e) {
          this.setState({s3Loading: false})
          this.responseSuccessErrorMessage((e?.response?.data?.message || e?.message), false)
        }
      }
  
      closePrintPreview = () => {
      this.setState({
        printPreviewPop: false,
        printPreviewData: [],
        pdfName: ''
      })
    }

  renderLeftSide = () => {
    try {
      this.state.testReportData?.forEach((element, index) => element.sno = index + 1)
      const columns = [
        {
          field: 'report_date', headerName: 'Reported Date', flex: 0.25,
          renderCell: (params) => (<Box>{params?.row?.report_date ? formatDate(params?.row?.report_date) : '-'}</Box>)
        },
        {
          field: 'report_type', headerName: 'Report Type', flex: 0.25,
          renderCell: (params) => (<Box>{params?.row?.report_type ? params?.row?.report_type?.length > 15 ?
            <Tooltip title={params?.row?.report_type} placement='top'><div>{params?.row?.report_type?.slice(0, 15) + '...'}</div></Tooltip> :
            params?.row?.report_type : '-'}</Box>)
        },
        {
          field: 'test_name', headerName: 'Test Details', flex: 0.25,
          renderCell: (params) => (<Box>{params?.row?.test_name ? params?.row?.test_name?.length > 15 ?
            <Tooltip title={params?.row?.test_name} placement='top'><div>{params?.row?.test_name?.slice(0, 15) + '...'}</div></Tooltip> :
            params?.row?.test_name : '-'}</Box>)
        },
        {
          field: 'action', headerName: 'Status', flex: 0.25,
          renderCell: (params) => (
            <Box display={'flex'} flexDirection={'row'}>
              {(params?.row?.status === 'Result Inprogress') || (params?.row?.status === "Specimen Collected") ? params?.row?.status :
                ((params?.row?.status === 'Result Delivered') || (params?.row?.status === 'Result Completed')) ?
                  <Tooltip title={params?.row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow>
                    <div>
                      <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                        disabled={params?.row?.is_outsource}
                        onClick={() => { this.getTestReportPrint(params?.row?.id, params?.row?.laboratory_id) }}
                        emed_tid={`doc_test_report_view_btn_${params.row.sno}`}
                      >View</Button>
                    </div>
                  </Tooltip>
                  : (params?.row?.status === 'Result Saved') || (params?.row?.status === "In Progress") ? <Typography emed_tid={`test_reports_status_text_${params?.row.id}`}>{params?.row?.status}</Typography> :
                    (params?.row?.is_investigation && (params?.row?.status === 'Completed' || params?.row?.status === 'Dispatched')) ?
                      <Tooltip title={params?.row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow emed_tid={`test_reports_view_tooltip_${params?.row.id}`}>
                        <div emed_tid={`test_reports_view_container_${params?.row.id}`}>
                          <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                            disabled={params?.row?.is_outsource}
                            onClick={() => { this.getFoInvestTestReportPrint(params?.row?.id, params?.row?.investigation_id) }}
                            emed_tid={`test_reports_view_btn_${params?.row.id}`}
                          >View</Button>
                        </div>
                      </Tooltip> :
                  (params?.row?.status === 'Result Saved') || (params?.row?.status === "In Progress") ? <Typography emed_tid={`test_reports_status_text_${params?.row.id}`}>{params?.row?.status}</Typography> :
                    (params?.row?.status === 'Completed')  || (params?.row?.status === 'Dispatched')?
                      <Tooltip title={params?.row?.is_outsource ? 'Outsource' : 'View'} placement="top" arrow emed_tid={`test_reports_view_tooltip_${params?.row.id}`}>
                        <div emed_tid={`test_reports_view_container_${params?.row.id}`}>
                          <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                            disabled={params?.row?.is_outsource}
                            onClick={() => { this.getFoRadiologyTestReportPrint(params?.row?.id, params?.row?.radiology_id) }}
                            emed_tid={`test_reports_view_btn_${params?.row.id}`}
                          >View</Button>
                        </div>
                      </Tooltip> :
                   params?.row?.file_name[0]?.result_img_url?.includes('.pdf') ?
                    <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                    <Button className='Common_Btn_Min_Width'
                      onClick={() => {
                        if (params?.row?.file_name?.length > 0) {
                          let imageFile = params?.row?.file_name?.length > 0 ? params?.row?.file_name : [];
                          let pdfFile = params?.row?.pdf_file?.length > 0 ? params?.row?.pdf_file : [];
                          this.setState({
                            // imageViewerPopup: true,
                            // viewOpen: true,
                            viewData: [],
                            viewImage: null
                          }, () => this.renderImage(imageFile, true))
                        } else {
                          this.errorMessage('No PDF to be view')
                        }
                      }}
                      emed_tid={`doc_test_report_view_pdf_btn_${params.row.sno}`}
                    >
                      <FileUploadIcon color='primary' />
                    </Button>
                    {(params?.row?.is_deletable_item === true) && <CommonDeleteButton size={"1.5vw"} onClick={this.handleDelete.bind(this, params?.row)} />}
                    </Box> :
                    <Box display={"flex"} gap={"0.5vw"} alignItems={"center"}>
                    <Button sx={{ textTransform: 'capitalize' }} className='Common_Btn_Min_Width'
                      onClick={() => {
                        if (params?.row?.file_name?.length > 0) {
                          let imageFile = params?.row?.file_name?.length > 0 ? params?.row?.file_name : [];
                          let pdfFile = params?.row?.pdf_file?.length > 0 ? params?.row?.pdf_file : [];
                          this.setState({
                            imageViewerPopup: true,
                            viewOpen: true,
                            viewData: [],
                            viewImage: null
                          }, () => this.renderImage(imageFile))
                        } else {
                          this.errorMessage('No image to be view')
                        }
                      }}
                      emed_tid={`doc_test_report_view_image_btn_${params.row.sno}`}
                    >View</Button>
                    {(params?.row?.is_deletable_item === true) && <CommonDeleteButton size={"1.5vw"} onClick={this.handleDelete.bind(this, params?.row)} />}
                    </Box>
              }
              {!params?.row?.is_deletable_item && (params?.row?.status === 'Completed' || params?.row?.status === 'Dispatched') ? this.moreActionOption(params?.row) : null}
            </Box>), disableExport: true
        },
      ]
      return (
        <DataGrid
          rows={this.state.testReportData}
          columns={columns}
          getRowId={(row) => row['sno']}
          page={this.state.page}
          pageSize={this.state.pageSize}
          localeText={{
            toolbarColumns: "",
            toolbarDensity: "",
            toolbarExport: "",
            toolbarFilters: "",
            toolbarExportPrint: ""
          }}
          sx={{ backgroundColor: Colors.white }}
          components={{
            Toolbar: CommonGridHeader.CommonToolBar,
            NoRowsOverlay: () => (
              <Box className='eMed_conf_nodata'>
                {'No Records To Be Shown'}
              </Box>
            )
          }}
          onPageChange={(newPage) => { this.setState({ page: newPage }) }}
          onPageSizeChange={(newPageSize) => this.setState({ pageSize: newPageSize })}
          rowsPerPageOptions={[10, 20, 30]}
          pagination
          headerHeight={40}
          disableSelectionOnClick
          loading={this.state.loading}
        />
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }

  closeWebCamPop = () => {
    this.setState({
      imgCapClked: false,
      CapturedImg: null
    })
  }

  addImgCapture = (data) => {
    if (data) {
      this.setState((prevState) => ({
        imageuploadList: [...prevState.imageuploadList, dataURItoFile(data, `report_file_${Date.now()}.jpg`)],
        imgCapClked: false
      }));
    }
  }

  UploadButton = (onClick, imgSrc, text) => {
    const { t } = this.props;
    const emedTidMap = {
      'Capture Image': 'doc_test_report_capture_image_btn',
      'Browse Files': 'doc_test_report_browse_files_btn'
    }
    return (
      <Button sx={{ textTransform: "capitalize" }}
        disabled={this.state.imageuploadList.length === 6}
        onClick={onClick}
        emed_tid={emedTidMap[text]}>
        <Box
          component="div"
          borderRadius="10px"
          border="1px dotted gray"
          height="10vw"
          width="12vw"
          display="flex"
          flexDirection="column"
          justifyContent="center"
          alignItems="center"
        >
          <Box component="img" src={imgSrc} height="2vw" width="2vw" />
          <Typography fontSize="0.9vw" color={Colors.SecondaryText} fontWeight={600} mt="0.5vw">
            {this.state.imageuploadList.length === 6 ? t("MaxUpload") : text}
          </Typography>
        </Box>
      </Button>
    )
  };

  getFoRadiologyTestReportPrint = (resultSummaryId,radialogyId,paymentStatus) => {
      try {
        RestAPIService.getAll((localGetItem("isNewBilling") === "true" ? Serviceurls.NEW_RAD_RESULT_PRINT : Serviceurls.RAD_RESULT_PRINT) + '?id=' + resultSummaryId + "&radiology_id=" + radialogyId)
          .then((response) => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.responseSuccessErrorMessage(error.response.data.message)
            } else {
              this.responseSuccessErrorMessage(error.message)
            }
          })
      } catch (error) {
        this.responseSuccessErrorMessage(error.message, false);
      }
    }

  getFoInvestTestReportPrint = (resultSummaryId,InvestID,paymentStatus) => {
      try {
        RestAPIService.getAll(Serviceurls.NEW_INVESTIGATION_RESULT_PRINT + '?id=' + resultSummaryId + "&investigation_id=" + InvestID)
          .then((response) => {
              const file = new Blob(
                [response.data],
                { type: 'application/pdf' });
              const fileURL = URL.createObjectURL(file);
              window.open(fileURL);
          }).catch((error) => {
            if (error?.response?.data?.message) {
              this.responseSuccessErrorMessage(error?.response?.data?.message)
            } else {
              this.responseSuccessErrorMessage(error.message)
            }
          })
      } catch (error) {
        this.responseSuccessErrorMessage(error.message, false);
      }
    }

  renderRightSide = () => {
    try {
      return (
        <Box>
          <Box component={'div'} height={'2.5vw'} display={'flex'} pl={'0.5vw'} alignItems={'center'}>
            <Typography fontSize={'0.9vw'} fontWeight={600} color={Colors.SecondaryText}>Test Report</Typography>
          </Box>
          <Box component={'div'} height={'48.5vh'} sx={{ background: Colors.white }} p={'1vw'} overflow={'scroll'}>
            <Box display={'flex'} mb={'1vw'}>
              <Autocomplete
                clearIcon
                size='small'
                sx={{ width: '14.5vw', mr: '1vw' }}
                freeSolo
                options={this.state.reportTypes.map((item) => item.label)}
                value={this.state.selectedReportType}
                limitTags={3}
                autoComplete='off'
                onChange={(event, newValue) => {
                  this.setState({
                    selectedReportType: newValue
                  })
                }}
                onInputChange={(event, newValue) => {
                  this.setState({ selectedReportType: newValue })
                }}
                renderInput={(params) => <TextField {...params} label='Select Report Type' emed_tid="doc_test_report_type_autocomplete" />}
              />
              <LocalizationProvider dateAdapter={AdapterDateFns}>
                <DatePicker
                  open={this.state.open}
                  onOpen={() => { this.setState({ open: true }) }}
                  onClose={() => { this.setState({ open: false }) }}
                  inputFormat="dd-MM-yyyy"
                  label={'Select Date'}
                  value={this.state.selectedDate}
                  autoComplete="off"
                  maxDate={DateTime.now()}
                  onChange={(value) => this.setState({ selectedDate: value })}
                  renderInput={(params) => <TextField onKeyDown={(e) => e.preventDefault()} size="small" sx={{ width: '14.5vw' }} {...params} onClick={() => { this.setState({ open: true }) }} emed_tid="doc_test_report_date_picker" />}
                />
              </LocalizationProvider>
            </Box>
            <Box component={'div'} mb={'1vw'}>
              <TextField
                size='small'
                fullWidth
                multiline
                rows={3}
                label="Test Details"
                value={this.state.testReportComments}
                onChange={(e) => this.setState({ testReportComments: e.target.value })}
                emed_tid="doc_test_report_details_input"
              />
            </Box>
            <Box component={'div'}>
              <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} sx={{ backgroundColor: Colors.white }} overflow={'scroll'}>
                <Box component={'div'} sx={{ backgroundColor: Colors.Background }} width={'29vw'} display={'flex'} justifyContent={'center'} alignItems={'center'}>
                  <Box component={'input'} type='file' sx={{ display: 'none' }}
                    multiple
                    accept="image/jpg, image/jpeg, image/png,application/pdf"
                    ref={this.uploadImage}
                    onChange={this.onImageHandler}
                  />
                  <Box display={"flex"} justifyContent={"space-between"} alignItems={"center"} gap={"0.5dvw"}>
                  {this.UploadButton(() => { this.setState({ imgCapClked: true }) }, ImagePaths.CameraCapture.default, "Capture Image")}
                  {this.UploadButton(() => this.uploadImage.current.click(), ImagePaths.LabUploadButton.default, "Browse Files")}
                  </Box>
                </Box>
              </Box>
            </Box>
            {this.state.imageuploadList?.length > 0 ?
              <Box component={'div'} display={'flex'} maxWidth={'29vw'} alignItems={'center'} justifyContent={'center'} overflow={'scroll'}>
                {this.state.imageuploadList?.map((image, index) => (
                  <Box component={'div'} key={index} mr={'0.5vw'} height={'5vw'} display={'flex'} alignItems={'center'}>
                    <Tooltip title={typeof (image) === "string" ? null : image?.name} arrow placement='top'>
                      <Box component={'img'}
                        onClick={() => {
                          if (typeof (image) === "string") {
                            if (image.split('.').pop() === "jpg" || image.split('.').pop() === "jpeg" || image.split('.').pop() === "JPG" || image.split('.').pop() === "png") {
                              this.setState({ isImgClicked: true, popUpOpen: true, selectedImage: image })
                            }
                            else {
                              window.open(image)
                            }
                          }
                        }}
                        src={typeof (image) === "string" ?
                          (image.split('.').pop() === "jpg" || image.split('.').pop() === "jpeg" || image.split('.').pop() === "JPG" || image.split('.').pop() === "png" ?
                            image : ImagePaths.DocumentPreview.default) : ((image?.type === "image/jpeg" || image?.type === "image/png") ? ImagePaths.ImagePreview.default : ImagePaths.DocumentPreview.default)}
                        height={'4vw'} width={'3.5vw'}
                      />
                    </Tooltip>
                    <Box><IconButton sx={{ position: 'relative', bottom: '1.2vw', right: '1.4vw' }} size="small"
                      onClick={() => {
                        this.setState({ selectedImage: null }, () => { this.onImageRemove(index) });
                      }}
                      emed_tid={`doc_test_report_remove_image_btn_${index}`}
                    >
                      <CancelTwoToneIcon fontSize='small' color="error" />
                    </IconButton>
                    </Box>
                  </Box>
                ))}
              </Box> : null}
          </Box>
          <Box component={'div'} display={'flex'} justifyContent={'center'} alignItems={'center'} height={'3vw'}>
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize', mr: '1vw' }}
              variant='outlined'
              onClick={() => this.onClearTestReportData()}
              emed_tid="doc_test_report_clear_btn"
            >Clear</Button>
            <Button
              sx={{ height: '2vw', width: '5vw', textTransform: 'capitalize' }}
              variant='contained'
              disabled={this.state.addTestData || getCachevalue('DoctorUserChanged') === 'true'}
              onClick={() => this.postTestReportData()}
              emed_tid="doc_test_report_add_btn"
            >Add</Button>
          </Box>
        </Box>
      )
    } catch (error) {
      this.errorMessage(error.message)
    }
  }
  HistoryPopup = () => {
    return (
      <div>
        <Modal open={this.state.historyPopup}>
          <Box component={"div"} className='eMed_Doc_Notes_Counsellor_Pop_Up' style={{ width: "70vw", height: "70vh", maxHeight: "100%" }}>
            <Box component={'div'} p={'0.75vw'} display={'flex'} justifyContent={'space-between'} alignItems={'center'} style={{ borderBottom: "1px solid gray" }}>
              <Typography fontSize={'0.95vw'} fontWeight={600} color={Colors.SecondaryText}>Laboratory Test Report History</Typography>
              <Button
                className='Common_Btn_Min_Width'
                onClick={() => this.setState({ historyPopup: false })}
              >
                <Box component={'img'} src={ImagePaths.LabCloseButton.default} height={'1vw'} width={'1vw'} />
              </Button>
            </Box>
            <Box sx={{ maxHeight: '60vh', overflow: 'auto', border: '1px solid lightgray' }} component={'div'}>
              <Table stickyHeader size='small'>
                <TableHead>
                  <TableRow>
                    <TableCell width={'20%'} sx={{ fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>Test Name</TableCell>
                    {this.state.test_date?.length > 0 ? this.state.test_date?.map((item) => (
                      <TableCell width={'200vw'} sx={{ textAlign: 'center', fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>{item}</TableCell>
                    )) : null}
                  </TableRow>

                </TableHead>
                <TableBody>
                  {this.state.labhistory?.length > 0 ? this.state.labhistory?.map((item, index) => (
                    <TableRow key={index}>
                      <TableCell style={{ fontSize: "0.9vw", fontWeight: 600 }}>{item.test_name}</TableCell>
                      {this.state.test_date?.length > 0 ? this.state.test_date?.map((date) => (
                        <TableCell width={'20%'} sx={{ textAlign: 'center', fontWeight: 600, fontSize: '0.9vw', color: Colors.SecondaryText, backgroundColor: Colors.Background }}>{item[date] ? item[date] : '-'}</TableCell>
                      )) : null}
                    </TableRow>
                  )) : null}
                </TableBody>
              </Table>
            </Box>
          </Box>
        </Modal>
      </div>
    )
  }
  render() {
    let attender = {
      lineOne: "Attender Name",
      lineTwo: `${this.state.patientDetails?.attender_name ? this.state.patientDetails?.attender_name :
        this.state.patientDetails?.caretaker_name ? this.state.patientDetails?.caretaker_name : "-"}`,
      lineFour: 'Contact Number',
      LineFive: `${this.state.patientDetails?.attender_mobile ? this.state.patientDetails?.attender_mobile :
        this.state.patientDetails?.caretaker_mobile ? this.state.patientDetails?.caretaker_mobile : "-"}`
    }
    let myUser = JSON.parse(localGetItem("loggedInUserInfo"))
    let UserData = myUser;
    return (
      <Box component={'div'} sx={{ backgroundColor: Colors.Background }} height={'74vh'} p={'0.5vw'}>
        <Box component={'div'} display={'flex'}>
          <Box component={'div'} className='doc_header_card' mr={'0.5vw'}>
            <CommonPatientDetails data={this.state.patientDetails} showDetailed={true} fromDoctor={true} />
          </Box>
          {(UserData?.service_type === 'DB') ? <Box component={'div'} onClick={() => { this.setState({ historyPopup: true }) }} className='doc_header_card' sx={{ width: "4.5vw", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", cursor: "pointer" }} mr={'0.5vw'}>
            <Box component={'img'} src={ImagePaths.PreviousPrescription.default} height={'1.8vw'} width={'1.8vw'} />
          </Box> : null}

          {this.HistoryPopup()}
          {/* <CommonPatientCard details={attender} showDetailed={true} /> */}
        </Box>
        <Box component={'div'} display={'flex'} mt={'0.5vw'} height={'61.5vh'}>
          <Box component={'div'} flex={0.65} overflow={'scroll'}>
            {this.renderLeftSide()}
          </Box>
          <Box component={'div'} flex={0.35} border={'1px solid lightgray'}>
            {this.renderRightSide()}
          </Box>
          {this.renderImageViewerPopup()}
        </Box>
        {
          this.state.imgCapClked && <OpenWebCamPopUP
            capturedImg={this.state.CapturedImg}
            closePopup={this.closeWebCamPop.bind(this)}
            addImgCapture={this.addImgCapture.bind(this)}
          />
        }
        {this.state.deletedPopup && <DeletePopup
          DeletTitle={"Are you sure you want to delete ?"}
          deleteAlertPopupClose={this.PopupClose.bind(this)}
          removeData={this.removeDataList.bind(this)}
        />}
        {this.state.isErrorMsg ?
          <ToastMsg
            severity={'error'}
            msg={this.state.isErrorMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        {this.state.successMsg ?
          <ToastMsg
            severity={'success'}
            msg={this.state.successMsgText}
            msgPop={this.msgClose.bind(this)}
          />
          : null}
        <Loader loaderOpen={this.state.isLoader} />
        {this.state.printPreviewPop ?
          <DocumentPreviewPop
            Data={this.state.printPreviewData}
            Title={this.state.pdfName}
            BillData={this.state.selectedRow}
            ClosePopUp={() => { this.closePrintPreview() }}
            history={this.props.history}
          /> : null}
      </Box>
    )
  }
}
